import React from 'react';
import PropTypes from 'prop-types';

import AgeGatingContainer from 'Components/Utility/Age/AgeGatingContainer';
import FluidImg from 'Components/Utility/FluidImg';
import VideoImgLoader from 'Components/Utility/Video/VideoImgLoader';
import SiteSlider from 'Components/Utility/SiteSlider/SiteSlider';

const ProductMediaSlider = ({
  bundleImages,
  videos,
  bundleVideos,
  ratings,
  screenshots,
  displayType,
  sizesOverride,
  productCoverOverrride, // show product front cover as the default VideoImgLoader image
  sliderSettings,
}) => {
  const carouselVideos = videos.map(video =>
    ({ video: true, src: video.src, cover: video.cover }),
  );
  const carouselBundleVideos = bundleVideos.map(video =>
    ({ video: true, src: video.src, cover: video.cover }),
  );

  return (
    <React.Fragment>
      <AgeGatingContainer lazyLoad={false} ratings={ratings} className="w-100 product-carousel-age-gating-container">
        <SiteSlider sliderSettings={sliderSettings} sliderClass="ProductMediaSlider">
          {carouselVideos.map(({ video, slug, src, cover }, i) =>
            <div className="w-100" key={`${slug}-${src}`}>
              {(video && displayType === 'bundle') ?
                <VideoImgLoader
                  cover={cover}
                  video={src}
                  coverSizeXl="740"
                  coverSizeLg="620"
                  coverSizeMd="710"
                  coverSizeSm="530"
                  coverSizeXs="420"
                  sizesOverride={sizesOverride}
                  location={'productCarousel'}
                  displayType={displayType}
                />
                :
                <VideoImgLoader
                  cover={productCoverOverrride ? cover : null}
                  video={src}
                  coverSizeXl="740"
                  coverSizeLg="620"
                  coverSizeMd="710"
                  coverSizeSm="530"
                  coverSizeXs="420"
                  sizesOverride={sizesOverride}
                  index={i}
                  location={'productCarousel'}
                  displayType={displayType}
                />
              }
            </div>,
          )}
          {carouselBundleVideos.map(({ video, slug, src, cover }, i) =>
            <div className="w-100" key={`${slug}-${src}`}>
              {(video && displayType === 'bundle') ?
                <VideoImgLoader
                  cover={i === 0 ? cover : null}
                  video={src}
                  coverSizeXl="740"
                  coverSizeLg="620"
                  coverSizeMd="710"
                  coverSizeSm="530"
                  coverSizeXs="420"
                  sizesOverride={sizesOverride}
                  location={'productCarousel'}
                  displayType={displayType}
                />
                :
                <VideoImgLoader
                  video={src}
                  coverSizeXl="740"
                  coverSizeLg="620"
                  coverSizeMd="710"
                  coverSizeSm="530"
                  coverSizeXs="420"
                  sizesOverride={sizesOverride}
                  location={'productCarousel'}
                  displayType={displayType}
                />
              }
            </div>,
          )}
          {bundleImages && bundleImages.map(bundleImage =>
            <div className="responsive-image-island" key={bundleImage.slug}>
              <div className="responsive-image responsive-image--16by9">
                <FluidImg
                  ratio16by9={displayType === 'game' || displayType === 'dlc'}
                  src={bundleImage.slug}
                  alt={bundleImage.alt}
                  sizesOverride={sizesOverride}
                />
              </div>
            </div>,
          )}
          {screenshots && screenshots.map(({ slug, alt }) =>
            <div className="responsive-image-island" key={slug}>
              <div className="responsive-image responsive-image--16by9">
                <FluidImg
                  ratio16by9={displayType === 'game' || displayType === 'dlc'}
                  src={slug}
                  alt={alt}
                  sizesOverride={sizesOverride}
                  className="ProductMediaSlider__img__foreground"
                />
                {displayType !== 'game' && displayType !== 'dlc' &&
                  <FluidImg
                    src={slug}
                    alt={alt}
                    sizesOverride={sizesOverride}
                    className="ProductMediaSlider__img__background"
                  />
                }
              </div>
            </div>,
          )}
        </SiteSlider>
      </AgeGatingContainer>
    </React.Fragment>
  );
};

ProductMediaSlider.propTypes = {
  bundleImages: PropTypes.arrayOf(PropTypes.shape({})),
  screenshots: PropTypes.arrayOf(PropTypes.object),
  videos: PropTypes.arrayOf(PropTypes.object),
  bundleVideos: PropTypes.arrayOf(PropTypes.object),
  ratings: PropTypes.shape({}),
  displayType: PropTypes.string,
  sizesOverride: PropTypes.string,
  productCoverOverrride: PropTypes.bool,
  sliderSettings: PropTypes.shape({}),
};

ProductMediaSlider.defaultProps = {
  bundleImages: [],
  screenshots: [],
  videos: [],
  bundleVideos: [],
  ratings: {},
  displayType: '',
  sizesOverride: '',
  productCoverOverrride: null,
  sliderSettings: {},
};

export default ProductMediaSlider;
